var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHat = function SvgIconHat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.487 9.61-1-.55-9-5h-.11a1.06 1.06 0 0 0-.19-.06h-.37a1.172 1.172 0 0 0-.2.06h-.11l-9 5a1 1 0 0 0 0 1.74l2.49 1.38v4.74a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-4.74l2-1.12v2.86a1 1 0 0 0 2 0v-3.44a1 1 0 0 0-.51-.87Zm-5.49 7.31a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-3.63l4.51 2.5.15.06h.09c.083.01.167.01.25 0 .083.01.167.01.25 0h.09a.47.47 0 0 0 .15-.06l4.51-2.5v3.63Zm-5-3.14-6.94-3.86 6.94-3.86 6.94 3.86-6.94 3.86Z",
    fill: "currentColor"
  })));
};
export default SvgIconHat;